import React, { FC, memo } from 'react';
import styled from 'styled-components';

const Wrapper = styled.span`
    width: ${(props) => props.width ?? '70%'};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    vertical-align: middle;
`;

interface TemplateProps {
    width?: string;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { width } = props;

    return (
        <Wrapper title={props.children} width={width}>
            {props.children}
        </Wrapper>
    );
});

export default Template;
